<template>
	<div class="edit-modal">
		<div class="edit-modal-content">
			<form action="" method="POST" @submit.prevent="save">
				<div class="title">
					<span>
						{{ title }}
					</span>
					<button
						class="btn close-icon"
						type="button"
						@click="$emit('close-modal')"
					>
						<img
							src="/static/img/icon-close.svg"
							alt="cerrar modal"
							height="24px"
							width="24px"
						>
					</button>
				</div>
				<div class="section text-center">
					<div
						v-for="(item, index) in items"
						:key="index"
						class="section-item">
            <div>
              <label :for="item.id" class="caption">
                Nombre
              </label>
              <input
                class="form-input"
                :id="item.id"
                label="Nombre"
                placeholder="Nombre"
                type="text"
                v-model="item.name" />
            </div>
            <div>
              <label class="caption">URL</label>
              <input
                class="form-input"
                label="Nombre"
                placeholder="Nombre"
                type="text"
                v-model="item.url" />
            </div>
					</div>
					<button
						class="btn btn-save mt-32"
						type="submit"
					>
						Guardar
					</button>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
	function save() {
		const navigation = this.items.map((item) => {
			const newNav = { ...item };
			newNav.description = newNav.description || 'home';
			return newNav;
		});
		this.$emit('save', navigation);
	}

	export default {
		name: 'edit-modal-nav',
		props: {
			items: {
				default: () => [],
				type: Array,
			},
			title: String,
		},
		methods: {
			save,
		},
	};
</script>

<style lang="scss" scoped>
	.edit-modal-content {
		position: relative;
		bottom: 10px;
	}
	
	.caption {
		font-size: 10px;
	}

	.close-icon {
		height: 24px;
		margin: 0px;
		padding: 0px;
		width: 24px;
	}


	.edit-modal {
		align-items: center;
		background-color: rgba(0, 0, 0, .8);
		display: flex;
		height: 100vh;
		justify-content: center;
		position: fixed;
		top: 0px;
		width: 100vw;
		z-index: 16;

		&-content {
			background-color: map-get($colors, white);
			max-width: 537px;
			width: 90%;
			z-index: 16;

			@media (max-width: 768px) {
				top: 24px;
			}
		}

		.section {
			padding: 0px 46px 20px;

			&-item {
				padding-bottom: 15px;
				text-align: left;
			}
		}
	}

	.title {
		align-items: center;
		background-color: map-get($colors, black-dark);
		color: map-get($colors, white);
		display: flex;
		flex-wrap: wrap;
		font-family: map-get($fonts, maison-bold);
		font-size: 24px;
		justify-content: space-between;
		height: 59px;
		padding: 0px 37px;
		text-transform: uppercase;
	}

	.btn-save {
		background-color: map-get($colors, black-dark);
		color: map-get($colors, white);
		font-family: map-get($fonts, open-bold);
		font-size: 14px;
		height: 45px;
		width: 132px;

		&.mt-32 {
			margin-top: 32px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/commons/edit-modal-nav.vue